<template>
  <div class="kpis-page">

    <div class="kpis-page-third">
      <div class="page-header">
        <h2>
          {{ $t('kpi.s14') }}
          <el-tooltip class="item" effect="newlight" :content="$t('kpi.s15')" placement="right">
            <i class="el-icon-question" style="color: #666;"></i>
          </el-tooltip>
          <span style="float:right; font-size:14px;">{{ $t('kpi.s38') }}：{{latestupdatetime}}</span>
        </h2>
      </div>
      <div class="kpis-complain">
        <div class="kpis-complain-overview">
          <el-row :gutter="20">
            <el-col :xs="8" :sm="8">
              <div class="kpis-complain-overview-item">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <div class="kpis-complain-overview-item-row colorred">
                      <h2>
                        {{ $t('kpi.s16') }}
                      </h2>
                      <h3>{{ totalcount.spu }}</h3>
                      <h4>SKU: {{ totalcount.sku }}</h4>
                    </div>
                    <div class="kpis-complain-overview-item-row mt20 colorgreen">
                      <h2>
                        {{ $t('kpi.s17') }}
                      </h2>
                      <h3>{{ totalcount.skusuccess }}</h3>
                      <!-- <h4>{{ $t('kpi.s32')}}: {{ totalcount.skusuccess }}</h4> -->
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="progresscircle">
                      <el-progress 
                        v-if="successpercent.type === 0"
                        type="circle" 
                        :percentage="successpercent.progress" 
                        :format="formatprogress1"
                        :stroke-width="10"
                        color="#1CAF9A"
                      >
                      </el-progress>
                      <el-progress 
                        v-if="successpercent.type > 0"
                        type="circle" 
                        :percentage="successpercent.progress" 
                        :format="formatprogress"
                        :stroke-width="10"
                        color="#1CAF9A"
                      >
                      </el-progress>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :xs="8" :sm="8">
              <div class="kpis-complain-overview-item">
                <h2>
                  {{ $t('kpi.s19') }}
                  <span style="font-size:12px; margin-left:15px;">{{ $t('kpi.s20') }}</span>
                </h2>
                <MiniBarChart :chartdata="timeschartdata" minibarid="minibarid"/>
              </div>
            </el-col>
            <el-col :xs="8" :sm="8">
              <div class="kpis-complain-overview-item">
                <h2>{{ $t('kpi.s25') }}</h2>
                <div class="kpis-balance-bar-container">
                  <div class="kpis-balance-bar">
                    <span class="kpis-balance-bar-used" :style="'width:' + jindutiao + ';'"></span>
                  </div>
                  <h3 v-if="tstype/1 === 1">
                    <span>{{ $t('kpi.s26') }}：{{ shengyu }} {{ $t('kpi.s28') }}</span>
                    <span>{{ $t('kpi.s29') }}：{{ yishiyong }}/{{zongdian}} {{ $t('kpi.s28') }}</span>
                  </h3>
                  <h3 v-if="tstype/1 === 2">
                    <span v-if="shengyu >= 0">{{ $t('kpi.s26') }}：{{ shengyu }} {{ $t('kpi.s27') }}</span>
                    <span v-if="shengyu < 0">{{ $t('kpi.s926') }}：{{ Math.abs(shengyu) }} {{ $t('kpi.s27') }}</span>
                    <span>{{ $t('kpi.s29') }}：{{ yishiyong }}/{{zongdian}}</span>
                  </h3>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="kpis-complain-list">

          <div class="tablebox">
            <el-table size="mini" 
              :cell-style="getTableCellStyle"
              tooltip-effect="dark" 
              :data="listdata" 
              style="width: 100%;"
              @sort-change="sortTableList"
              @cell-dblclick="editStatus"
            >
              <el-table-column label="AssetId" prop="assetID" width="80"></el-table-column>
              <el-table-column label="IPP Code" prop="ippcode" width="120">
                <template slot-scope="scope">
                  <span v-if="scope.row.iseditippcode == false">{{ scope.row.ippcode }}</span>
                  <el-input v-model="scope.row.ippcode" v-if="scope.row.iseditippcode == true" @blur="saveIppcode(scope)" size="mini"></el-input>
                </template>
              </el-table-column>
              <el-table-column :label="$t('jgjk.s12')" width="140">
                <template slot-scope="scope">
                  <i class="channelicon" :class="scope.row.channelicon"></i>
                </template>
              </el-table-column>
              <el-table-column :label="$t('kpi.s30')" show-overflow-tooltip>
                <template slot-scope="scope">
                  <a :href="scope.row.assetURL" target="_blank">{{ scope.row.assettitle }}</a>
                </template>                
              </el-table-column>
              <el-table-column :label="$t('kpi.s31')" prop="skumap" show-overflow-tooltip></el-table-column>
              <el-table-column sortable='custom' :label="$t('kpi.s32')" width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                  <a :href="scope.row.shopURL" target="_blank">{{ scope.row.shopname }}</a>
                </template>
              </el-table-column>
              <el-table-column :label="$t('kpi.s33')" prop="sellername" show-overflow-tooltip></el-table-column>
              <el-table-column sortable='custom' :label="$t('kpi.s34')" prop="statustype" width="120">
                <template slot-scope="scope">
                  <span v-if="scope.row.isedittype == false">{{ scope.row.statustype }}</span>
                  <el-select v-if="scope.row.isedittype == true" v-model="scope.row.status" placeholder="请选择" size="mini" @change="saveTypes(scope)">
                    <el-option
                      v-for="item in options1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column sortable='custom' :label="$t('kpi.s35')" prop="tsdate" width="120"></el-table-column>
              <el-table-column sortable='custom' :label="$t('kpi.s36')" prop="finishtime" width="100"></el-table-column>
              <el-table-column sortable='custom' :label="$t('kpi.s37')" prop="count" width="100"></el-table-column>
              <el-table-column v-if="showtsbtn == true" sortable='custom' :label="$t('Seller.t13')" prop="descs" width="100" show-overflow-tooltip></el-table-column>
            </el-table>
          </div>

          <div class="pagewrap">
            <el-pagination
              small
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentpage"
              popper-class="pagesizeclass"
              :page-sizes="[25, 50, 100]"
              :page-size="indicatorquery.size"
              layout="total, prev, pager, next, sizes"
              :total="pagingtotal">
            </el-pagination>      
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import MiniBarChart from '@/components/Charts/MiniBarChart.vue'
export default {
  components: {
    MiniBarChart,
  },
  data(){
    return{
      brandid: this.$route.params.Id,
      latestupdatetime: '',
      totalsku: {},
      totalseller: {},
      lowpricesku: {
        trend: {
          xdata: [],
          ydata: []
        }
      },
      lowpriceseller: {
        trend: {
          xdata: [],
          ydata: []
        }
      },
      infringementsku: {
        trend: {
          xdata: [],
          ydata: []
        }
      },
      infringementseller: {
        trend: {
          xdata: [],
          ydata: []
        }
      },
      indicatorquery: {
        subid: this.$route.params.Id,
        page: 1,
        size: 25,
        order: 21
      },
      timeschartdata: [],
      successpercent: {},
      listdata: [],
      currentpage: 1,
      pagingtotal: 0,
      totalcount: {
        sku: 0,
        spu: 0,
        skusuccess: 0,
        spusuccess: 0
      },
      tstype: 0,
      shengyu: 0,
      yishiyong: 0,
      zongdian: 0,
      jindutiao: '100%',
      showlists: false,
      showinfringements: false,
      lists: [],
      options1: [{
        value: '1',
        label: this.$t('kpi.s39')
      }, {
        value: '2',
        label: this.$t('kpi.s40')
      }, {
        value: '6',
        label: this.$t('kpi.s47')
      }, {
        value: '7',
        label: this.$t('kpi.s48')
      }, {
        value: '8',
        label: this.$t('kpi.s50')
      }, {
        value: '3',
        label: this.$t('kpi.s41')
      }, {
        value: '5',
        label: this.$t('kpi.s43')
      }],
      value1: '1',
      ippcode: '',
      statuslists: [],
      showtsbtn: false
    }
  },

  mounted(){
    // this.lists.forEach(item => {
    //   item.channelicon = this.setChannel(item.channelname).src
    //   item.statustype = this.setTypes(item.status)
    //   item.tsdate = this.checkInvaliddate(item.tsdate)
    //   item.isedittype = false
    // })
    let pkglist = JSON.parse(localStorage.getItem("price")).val
    let currentpkg = pkglist.find(o => o.subid/1 === this.brandid/1)

    this.showinfringements = currentpkg.level/1 === 3 ? true : false
    this.getDashboard()
    this.listStatus()
    this.getIndicatorCount()
    this.getIndicatorList()
  },

  methods: {

    /**
     * showlists
     */
    listStatus: function(){
      let that = this
      let _objstorage = JSON.parse(localStorage.getItem("price")).val
      let mapobj = _objstorage.filter(item => {
        return item.subid/1 === that.brandid/1
      })
      this.showtsbtn = mapobj[0].tscount == null ? false : true
    },

    getDashboard: function(){
      let that = this
      let url = that.API_URL + '/v3/commerce/indicator/dashboard?subid=' + that.$route.params.Id
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
				crossDomain: true,
        success: function(data){
          console.log('getDashboard', data)

          let infringementlist = data.results[6][0]
          let lowpricelist = data.results[7][0]

          // 本期侵权率
          let currentinfringementsku = infringementlist.length > 0 ? infringementlist[0].skurate : 0
          let currentinfringementsku_p = infringementlist.length > 1 ? currentinfringementsku - infringementlist[1].skurate : 0
          // 本期侵权卖家占比
          let currentinfringementseller = infringementlist.length > 0 ? infringementlist[0].shoprate : 0
          let currentinfringementseller_p = infringementlist.length > 1 ? currentinfringementseller - infringementlist[1].shoprate : 0
          // 本期低价率
          let currentlowpricesku = lowpricelist.length > 0 ? lowpricelist[0].skurate : 0
          let currentlowpricesku_p = lowpricelist.length > 1 ? currentlowpricesku - lowpricelist[1].skurate : 0
          // 本期低价卖家占比
          let currentlowpriceseller = lowpricelist.length > 0 ? lowpricelist[0].shoprate : 0
          let currentlowpriceseller_p = lowpricelist.length > 1 ? currentlowpriceseller - lowpricelist[1].shoprate : 0

          // 最近更新时间
          that.latestupdatetime = that.$moment(data.results[8][0].scoreTime).utc().format('YYYY-MM-DD')
          // 累计SKU
          that.totalsku = {
            last: that.millonFormat(data.results[0][0].lastskuweekCount),
            currenthtml: that.setCompare(that.millonFormat(data.results[0][0].skuweekCount), data.results[0][0].skuweekRate)
          }
          // 累计卖家
          that.totalseller = {
            last: that.millonFormat(data.results[1][0].lastshopweekCount),
            currenthtml: that.setCompare(that.millonFormat(data.results[1][0].shopweekCount), data.results[1][0].shopweekRate)
          }
          // 低价SKU
          that.lowpricesku = {
            last: that.millonFormat(data.results[2][0].lastskuweeklowCount),
            currenthtml: that.setCompare(that.millonFormat(data.results[2][0].skuweeklowCount), data.results[2][0].skuweeklowRate),
            percentagehtml: that.setPercentage(currentlowpricesku, currentlowpricesku_p),
            trend: {
              xdata: lowpricelist.reverse().map(item => {
                return item.weeks
              }),
              ydata: lowpricelist.reverse().map(item => {
                return item.skurate * 100
              })
            }
          }
          // 低价卖家
          that.lowpriceseller = {
            last: that.millonFormat(data.results[3][0].lastshopweeklowCount),
            currenthtml: that.setCompare(that.millonFormat(data.results[3][0].shopweeklowCount), data.results[3][0].shopweeklowRate),
            percentagehtml: that.setPercentage(currentlowpriceseller, currentlowpriceseller_p),
            trend: {
              xdata: infringementlist.reverse().map(item => {
                return item.weeks
              }),
              ydata: infringementlist.reverse().map(item => {
                return item.shoprate * 100
              })
            }
          }
          // 侵权SKU
          that.infringementsku = {
            last: that.millonFormat(data.results[4][0].lastskuweekqinCount),
            currenthtml: that.setCompare(that.millonFormat(data.results[4][0].skuweekqinCount), data.results[4][0].skuweekqinRate),
            percentagehtml: that.setPercentage(currentinfringementsku, currentinfringementsku_p),
            trend: {
              xdata: infringementlist.reverse().map(item => {
                return item.weeks
              }),
              ydata: infringementlist.reverse().map(item => {
                return item.skurate * 100
              })
            }
          }
          // 侵权卖家
          that.infringementseller = {
            last: that.millonFormat(data.results[5][0].lastshopweekqinCount),
            currenthtml: that.setCompare(that.millonFormat(data.results[5][0].shopweekqinCount), data.results[5][0].shopweekqinRate),
            percentagehtml: that.setPercentage(currentinfringementseller, currentinfringementseller_p),
            trend: {
              xdata: lowpricelist.reverse().map(item => {
                return item.weeks
              }),
              ydata: lowpricelist.reverse().map(item => {
                return item.shoprate * 100
              })
            }
          }


        },
        error: function(err){
          console.log(err)
        }
      })      
    },

    /**
     * 格式化涨跌
     */
    setCompare: function(current, rate){
      let _rate = rate >=0 ? '+' + (rate * 100).toFixed(2) + '%' : (rate * 100).toFixed(2) + '%'
      let h2 = rate >=0 ? current + '<span class="report-numcarts-color-red"><i class="el-icon-sell"></i> ' + _rate + '</span>' :
                          current + '<span class="report-numcarts-color-green"><i class="el-icon-sold-out"></i> ' + _rate + '</span>'
      return h2
    },

    /**
     * 格式化比例
     */
    setPercentage: function(p, rate){
      let _rate = rate >=0 ? '+' + (rate * 100).toFixed(2) + '%' : (rate * 100).toFixed(2) + '%'
      let html = rate >=0 ? (p * 100).toFixed(2) + '%' + '<span class="report-numcarts-color-red"><i class="el-icon-sell"></i> ' + _rate + '</span>' :
          (p * 100).toFixed(2) + '%' + '<span class="report-numcarts-color-green"><i class="el-icon-sold-out"></i> ' + _rate + '</span>'
      return html
    },

    /**
     * 投诉记录
     */
    getIndicatorList: function(){
      let that = this
      let url = that.API_URL + '/v3/commerce/indicator/paging'
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        data: that.indicatorquery,
        changeOrigin: true,
				crossDomain: true,
        success: function(data){
          let _list = data.results[1]
          _list.forEach(item => {
            item.isedittype = false,
            item.iseditippcode = false,
            item.channelicon = that.setChannel(item.channelname).src
            item.statustype = that.setTypes(item.status)
            item.tsdate = that.checkInvaliddate(item.tsdate)
            item.finishtime = item.tscgdate == '' && item.tssbdate == '' ? '' : item.tscgdate != '' && item.tscgdate != null ? that.checkInvaliddate(item.tscgdate) : that.checkInvaliddate(item.tssbdate)
          })
          that.pagingtotal = data.results[0][0].Count
          that.listdata = _list
        },
        error: function(err){
          console.log(err)
        }
      })
    },

    /**
     * 修改每页显示条数
     */
    handleSizeChange(val) {
      let that = this
      that.currentpage = 1
      that.indicatorquery.page = 1
      this.indicatorquery.size = val
      that.getIndicatorList()
    },

    /**
     * 翻页
     */
    handleCurrentChange(val) {
      this.indicatorquery.page = val
      this.getIndicatorList()
    },

    /**
     * 投诉记录统计
     */
    getIndicatorCount: function(){
      let that = this
      let url = that.API_URL + '/v3/commerce/indicator/tsCount?subid=' + that.$route.params.Id
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
				crossDomain: true,
        success: function(data){
          console.log('getIndicatorCount', data)

          // 处理时长
          let _sysavg = (data.results.sysAvgCount * 1).toFixed(2)
          let _avg = (data.results.avgCount * 1).toFixed(2)
          that.timeschartdata = [{
            value: _sysavg,
            itemStyle: {
                color: '#F0AD4E'
            }
          },{
            value: _avg/1 === 0 ? '' : _avg,
            itemStyle: {
                color: '#428bca'
            }
          },{
            value: data.results.maxtimeCount/1 === 0 ? '' : data.results.maxtimeCount,
            itemStyle: {
                color: '#D9534F'
            }
          },{
            value: data.results.mintimeCount/1 === 0 ? '' : data.results.mintimeCount,
            itemStyle: {
                color: '#1CAF9A'
            }
          }]

          let _p1 = data.results.spuTotalCount/1 == 0 || data.results.spuTotalCount == null ?
                    0 : ((data.results.spuSCount/data.results.spuTotalCount) * 100).toFixed(2)
          that.successpercent = {
            arr: [data.results.spuTotalCount, data.results.spuSCount],
            formatter: _p1 + '%\n' + that.$t('kpi.s18'),
            progress: _p1 * 1,
            type: data.results.avgCount
          }

          console.log(that.successpercent)

          that.totalcount = {
            sku: that.millonFormat(data.results.skuTotalCount),
            spu: that.millonFormat(data.results.spuTotalCount),
            skusuccess: that.millonFormat(data.results.skuSCount),
            spusuccess: that.millonFormat(data.results.spuSCount)
          }

          that.tstype = data.results.tsType
          let _objstorage = JSON.parse(localStorage.getItem("price")).val
          let mapobj = _objstorage.filter(item => {
            return item.subid/1 === that.brandid/1
          })
          let brandint = mapobj[0].init
          let brandexp = mapobj[0].expire
          
          let _months1 = that.$moment(brandexp).diff(that.$moment(brandint),'months') + 1
          let _months2 = that.$moment(brandexp).diff(that.$moment(new Date()),'months') + 1
          if(data.results.tsType/1 === 1){
            that.shengyu = _months2
            that.yishiyong = _months1 - _months2
            that.zongdian = _months1
            that.jindutiao = (_months2/_months1) * 100 + '%'
          }
          if(data.results.tsType/1 === 2){
            that.shengyu = data.results.tsTcount - data.results.tscount
            that.yishiyong = data.results.tscount
            that.zongdian = data.results.tsTcount
            that.jindutiao = ((data.results.tsTcount - data.results.tscount)/data.results.tsTcount) * 100 + '%'
          }

        },
        error: function(err){
          console.log(err)
        }
      })
    },

    // formatprogress: function(percentage){
    //   let that = this
    //   if(percentage * 1 === 0){
    //     return that.$t('kpi.s49')
    //   }else{
    //     return `${percentage}%` + `\n` + that.$t('kpi.s18')
    //   }
    // },
    formatprogress: function(percentage){
      let that = this
      return `${percentage}%` + `\n` + that.$t('kpi.s18')
    },
    formatprogress1: function(){
      let that = this
      return that.$t('kpi.s49')
    },

    /**
     * 投诉状态转换
     * 1.待处理 2.处理中 3.平台审核不通过 4.撤销投诉 5.处理成功
        1.待处理 
        2.处理中/取证中
        3.处理失败
        5.处理成功 
        6.已发函/预立案
        7.排期开庭
     */
    setTypes: function(n){
      let txt = ''
      switch (n) {
        case "1":
          txt = this.$t('kpi.s39'); // 待处理
          break;
        case "2":
          txt = this.$t('kpi.s40'); // 处理中/取证中
          break;
        case "3":
          txt = this.$t('kpi.s41'); // 处理失败
          break;
        case "5":
          txt = this.$t('kpi.s43'); // 处理成功
          break;
        case "6":
          txt = this.$t('kpi.s47'); // 已发函/预立案
          break;
        case "7":
          txt = this.$t('kpi.s48'); // 排期开庭
          break;
        case "8":
          txt = this.$t('kpi.s50'); // 案件处理中
          break;
        default:
          txt = "";
          break;
      }
      return txt      
    },
    
    /**
     * 自定义排序
     */
    sortTableList: function(column){
      let that = this
      if(column.order == "ascending"){
        switch(column.prop) {
          case 'shopname':
            that.indicatorquery.order = '00'
            break
          case 'statustype':
            that.indicatorquery.order = '10'
            break
          case 'tsdate':
            that.indicatorquery.order = '20'
            break
          case 'finishtime':
            that.indicatorquery.order = '30'
            break
          case 'count':
            that.indicatorquery.order = '40'
            break
          case 'descs':
            that.indicatorquery.order = '50'
            break
        }
      }
      if(column.order == "descending"){
        switch(column.prop) {
          case 'shopname':
            that.indicatorquery.order = '01'
            break
          case 'statustype':
            that.indicatorquery.order = '11'
            break
          case 'tsdate':
            that.indicatorquery.order = '21'
            break
          case 'finishtime':
            that.indicatorquery.order = '31'
            break
          case 'count':
            that.indicatorquery.order = '41'
            break
          case 'descs':
            that.indicatorquery.order = '51'
            break
        }
      }
      if(column.order == null){
        that.indicatorquery.order = ''
      }
      that.getIndicatorList()
    },

    checkInvaliddate: function(d){
      let that = this
      let _d = d == null || d == '' ? '' : that.$moment(d).utc(8).format('YYYY-MM-DD')
      return _d
    },

    editStatus: function(row, column){
      let that = this
      if(column.property == 'ippcode'){
        row.iseditippcode = true
        // that.ippcode = row.ippcode
      }
      if(column.property == 'statustype'){
        row.isedittype = true
        // that.value1 = row.status
      }
    },

    saveTypes: function(row){
      let that = this
      let _url = that.API_URL + '/v3/price/statistics/updatetssku'
      let _query = {
        skulist:[{
          channelId: row.row.channelId,
          itemCode: row.row.itemcode,
          shopId: row.row.shopId,
          assetid: row.row.assetID,
          descs: row.row.descs,
          tsdate: row.row.tsdate != null && row.row.tsdate != '' && row.row.tsdate != undefined ? row.row.tsdate : that.$moment(new Date()).format('YYYY-MM-DD'),
          tscgdate: row.row.status * 1 == 5 ? that.$moment(new Date()).format('YYYY-MM-DD') : row.row.tscgdate,
          tssbdate: row.row.status * 1 == 3 ? that.$moment(new Date()).format('YYYY-MM-DD') : row.row.tssbdate,
          ippcode: row.row.ippcode,
          status: row.row.status
        }],
        subid: that.$route.params.Id/1
      }
      $.ajax({
        url: _url,
        type: "POST",
        changeOrigin: true,
        dataType: "json",
        contentType: "application/json",
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        data: JSON.stringify(_query),
        success: function(res) {
          console.log(res)
          that.$message({
            message: 'success',
            type: 'success'
          })
          that.listdata[row.$index].isedittype = false
          that.listdata[row.$index].status = row.row.status
          that.listdata[row.$index].statustype = that.setTypes(row.row.status)
        },
        error: function(response) {
          console.log('saveTypes', response)
        }
      })
    },

    saveIppcode: function(row){
      let that = this
      let _url = that.API_URL + '/v3/price/statistics/updatetssku'
      let _query = {
        skulist:[{
          channelId: row.row.channelId,
          itemCode: row.row.itemcode,
          shopId: row.row.shopId,
          assetid: row.row.assetID,
          descs: row.row.descs,
          tsdate: row.row.tsdate != null && row.row.tsdate != '' && row.row.tsdate != undefined ? row.row.tsdate : that.$moment(new Date()).format('YYYY-MM-DD'),
          tscgdate: row.row.status * 1 == 5 ? that.$moment(new Date()).format('YYYY-MM-DD') : row.row.tscgdate,
          tssbdate: row.row.status * 1 == 3 ? that.$moment(new Date()).format('YYYY-MM-DD') : row.row.tssbdate,
          ippcode: row.row.ippcode,
          status: row.row.status
        }],
        subid: that.$route.params.Id/1
      }
      $.ajax({
        url: _url,
        type: "POST",
        changeOrigin: true,
        dataType: "json",
        contentType: "application/json",
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        data: JSON.stringify(_query),
        success: function(res) {
          console.log(res)
          that.$message({
            message: 'success',
            type: 'success'
          })
          that.listdata[row.$index].iseditippcode = false
        },
        error: function(response) {
          console.log('saveTypes', response)
        }
      })
    }

  }

}
</script>
